import { render, staticRenderFns } from "./ReactMountPcpHistorico.vue?vue&type=template&id=546610d2"
import script from "./ReactMountPcpHistorico.vue?vue&type=script&lang=ts"
export * from "./ReactMountPcpHistorico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546610d2')) {
      api.createRecord('546610d2', component.options)
    } else {
      api.reload('546610d2', component.options)
    }
    module.hot.accept("./ReactMountPcpHistorico.vue?vue&type=template&id=546610d2", function () {
      api.rerender('546610d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountPcpHistorico.vue"
export default component.exports